
import React from "react";
import { Schemes } from "../../utils";
import { i18nManager } from "../../i18n";
import { PreviewLink } from "./PreviewLink";
import { Button, Checkbox, Classname, Dropdown, FormControl, NoseurObject, Scheme, TextInput } from "@rivtn/noseur";
import { ConfirmDialog } from "../shared/ConfirmDialog";

export interface MobileAppDesignProps {
    name?: string;
    version?: string;
    designId?: string;
    minIosSdk?: string;
    packageName?: string;
    minAndroidSdk?: string;
    leftPanelStyle?: React.CSSProperties;
}

export interface IMobileAppDesign {
    name: string;
    external_id: string;
    outside_plan: boolean;
    preview_image_location: string;
    customizables?: {
        value?: any;
        defaultValue: any;
        label: string | NoseurObject<string>;
    }[];
}

function MobileAppDesign(props: MobileAppDesignProps) {

    const pageDesigns: IMobileAppDesign[] = [
        {
            name: "Default",
            external_id: "1",
            outside_plan: false,
            preview_image_location: "https://images.stockcake.com/public/6/f/6/6f6a0565-96eb-4dda-8c8f-9c0d9a8afdf0_large/vivid-sunset-sky-stockcake.jpg",
            customizables: [
                {
                    label: "Primary",
                    value: "#E98F08",
                    defaultValue: "#E98F08",
                },
                {
                    defaultValue: "#6D6D6D",
                    label: {
                        en: "Text",
                    },
                },
                {
                    value: "#FF1F00",
                    label: "Active Text",
                    defaultValue: "#FF1F00",
                },
                {
                    value: "#C3B0AD",
                    defaultValue: "#C3B0AD",
                    label: {
                        en: "Background",
                    },
                }
            ]
        },
        {
            name: "Moon",
            external_id: "2",
            outside_plan: false,
            preview_image_location: "https://upload.wikimedia.org/wikipedia/commons/e/e1/FullMoon2010.jpg",
            customizables: [
                {
                    value: "#C3B0AD",
                    defaultValue: "#C3B0AD",
                    label: {
                        en: "Background",
                    },
                }
            ]
        },
        {
            name: "Sun",
            external_id: "3",
            outside_plan: true,
            preview_image_location: "https://science.nasa.gov/wp-content/uploads/2023/05/pia03149-copy.jpg",
        },
        {
            name: "Galaxy",
            external_id: "4",
            outside_plan: true,
            preview_image_location: "https://cdn.britannica.com/38/111338-050-D23BE7C8/Stars-NGC-290-Hubble-Space-Telescope.jpg",
            customizables: [
                {
                    label: "Primary",
                    value: "#E98F08",
                    defaultValue: "#E98F08",
                },
                {
                    value: "#C3B0AD",
                    defaultValue: "#C3B0AD",
                    label: {
                        en: "Background",
                    },
                }
            ],
        },
        {
            external_id: "5",
            name: "Ocean Blue",
            outside_plan: true,
            preview_image_location: "https://assets.weforum.org/article/image/Mg3mkTPk21cznwxI9GOgqJCatFJrA8CIW749SWRQ4Dc.jpg",
            customizables: [
                {
                    label: "Primary",
                    value: "#E98F08",
                    defaultValue: "#E98F08",
                },
                {
                    defaultValue: "#6D6D6D",
                    label: {
                        en: "Text",
                        en_UK: "Textico",
                    },
                },
            ],
        }
    ];
    const minimumIosSdks = [
        "21",
        "22",
        "23",
        "24",
        "25",
    ];
    const minimumAndroidSdks = [
        "21",
        "22",
        "23",
        "24",
        "25",
    ];
    const labels = i18nManager.Labels.page_design;
    const [selectedMobileAppDesign, setSelectedMobileAppDesign] = React.useState<IMobileAppDesign | undefined>(pageDesigns.find((pd) => pd.external_id === props.designId));

    React.useEffect(() => {

    }, []);

    return (<div className="page-design">
        <div className="container">
            <div className="left-panel">
                <span className="t">{labels.select_design}</span>
                <div className="designs" style={props.leftPanelStyle}>
                    {pageDesigns?.map((pageDesign) => (<div key={pageDesign.name} className={Classname.build("design", { "active": pageDesign.name === selectedMobileAppDesign?.name })} onClick={() => setSelectedMobileAppDesign(pageDesign)}>
                        <img src={pageDesign.preview_image_location} alt={pageDesign.name} />
                        <span>{pageDesign.name}</span>
                        {pageDesign.outside_plan && (<i className="fa fa-star" />)}
                    </div>))}
                </div>
                <span className="hint">{labels.scroll_down_for_more}</span>
            </div>
            <div className="mobile-main-panel">
                <div className="controls main-panel" style={{ height: "100%" }}>
                    {selectedMobileAppDesign?.customizables?.length && (<>
                        <div className="headr">
                            <span className="t">{labels.customize}</span>
                            <span className="link">{labels.reset}</span>
                        </div>
                        <div className="customizables">
                            {selectedMobileAppDesign?.customizables?.map((customizable) => {
                                const backgroundColor = customizable.value ?? customizable.defaultValue;
                                const label = typeof customizable.label === "string"
                                    ? customizable.label
                                    : customizable.label[i18nManager.ActiveLanguage] ?? Object.values(customizable.label)[0];

                                return (<div key={label} className="customizable">
                                    <span>{label}</span>
                                    <div style={{ backgroundColor }} />
                                </div>);
                            })}
                        </div>
                    </>)}
                    <div className="mob-config">
                        <div style={{ display: "flex" }}>
                            <FormControl isFieldset fill label={labels.mobile.name}
                                rightContent={<i className="fa fa-refresh" style={{ cursor: "pointer" }} onClick={() => {

                                }} />}>
                                <TextInput fill disabled defaultValue={props.name} />
                            </FormControl>
                            <FormControl isFieldset fill label={labels.mobile.version} style={{ marginLeft: 15 }}
                                rightContent={<i className="fa fa-refresh" style={{ cursor: "pointer" }} onClick={() => {

                                }} />}>
                                <TextInput fill disabled defaultValue={props.version} />
                            </FormControl>
                        </div>
                        <FormControl isFieldset fill label={labels.mobile.package_name} style={{ marginTop: 15 }}
                            rightContent={<i className="fa fa-refresh" style={{ cursor: "pointer" }} onClick={() => {

                            }} />}>
                            <TextInput fill disabled defaultValue={props.packageName} />
                        </FormControl>
                        <div style={{ display: "flex" }}>
                            <Dropdown fill selectedOptionIndex={minimumAndroidSdks.findIndex((o) => o === props.minAndroidSdk)}
                                style={{ width: "100%" }} formControlProps={{
                                    fill: true,
                                    isFieldset: true,
                                    style: { marginTop: 10 },
                                    label: labels.mobile.android_min_sdk,
                                }} options={minimumAndroidSdks.map((value) => ({ label: value, value }))}
                                onSelectOption={(o) => {

                                }} />
                            <Dropdown fill selectedOptionIndex={minimumIosSdks.findIndex((o) => o === props.minIosSdk)}
                                style={{ width: "100%" }} formControlProps={{
                                    fill: true,
                                    isFieldset: true,
                                    style: { marginTop: 10, marginLeft: 10 },
                                    label: labels.mobile.ios_min_ver,
                                }} options={minimumIosSdks.map((value) => ({ label: value, value }))}
                                onSelectOption={(o) => {

                                }} />
                        </div>
                        <Checkbox scheme={Schemes.OMNEHOST} style={{ marginTop: 20 }} label={labels.mobile.make_auth_required} />
                        <Checkbox scheme={Schemes.OMNEHOST} style={{ marginTop: 20 }} label={labels.mobile.enable_notifications} />
                        <Checkbox scheme={Schemes.OMNEHOST} style={{ marginTop: 20 }} label={labels.mobile.enable_user_team_management} />
                        <Checkbox scheme={Schemes.OMNEHOST} style={{ marginTop: 20 }} label={labels.mobile.enable_analytics} />
                        <p style={{ marginTop: 20 }}>
                            <span className="link">{labels.mobile.config_anal}</span>{" - "}
                            <span className="link">{labels.mobile.view_analytics_dashboard}</span>
                        </p>
                        <p className="link">{labels.mobile.remote_debug}</p>
                        <p style={{ marginTop: 20 }}>
                            <span>{labels.mobile.android_down}</span>{" "}
                            <span className="link">{labels.mobile.debug}</span>{", "}
                            <span className="link">{labels.mobile.release}</span>
                        </p>
                        <p style={{ marginTop: 20 }}>
                            <span>{labels.mobile.ios_down}</span>{" "}
                            <span className="link">{labels.mobile.debug}</span>{", "}
                            <span className="link">{labels.mobile.release}</span>
                        </p>
                        <p style={{ marginTop: 20 }}>
                            <span>{labels.mobile.source}</span>{" "}
                            <span className="link">{labels.mobile.android}</span>{", "}
                            <span className="link">{labels.mobile.ios}</span>{", "}
                            <span className="link">{labels.mobile.react_native}</span>
                        </p>
                        <p style={{ marginTop: 20 }}>
                            <span className="link" onClick={configureAndroidKeystore}>{labels.mobile.configure_android_keystore}</span>
                            { }
                        </p>
                    </div>
                </div>
                <iframe src="http://localhost:3901/" />
            </div>
        </div>
    </div>);

    function configureAndroidKeystore() {
        const dialogLabels = labels.mobile.dialog.keystore;
        const dialogErrorRef = { current: null } as any;

        const dialog = ConfirmDialog({
            closable: true,
            style: { maxWidth: 500 },
            title: dialogLabels.title,
            confirmScheme: Scheme.DANGER,
            content: (<div style={{ display: "flex", flexDirection: "column" }}>
                <p>{dialogLabels.desc}</p>
                <p style={{ color: "#FF7171", marginTop: 0 }}>{dialogLabels.info}</p>
                <p style={{ marginTop: 10 }} className="link danger">{dialogLabels.generate}</p>
                <p style={{ marginTop: 2 }} className="link">{dialogLabels.upload}</p>
                <p style={{ marginTop: 2 }} className="link">{dialogLabels.remove}</p>
                <div ref={dialogErrorRef} className="error" style={{ alignSelf: "flex-start" }}> </div>
            </div>),
        });
        dialog.show();
    }

}

export default MobileAppDesign;
